/** Hostnames allowed as `return_to` after Tawan Spa login (Dr. Hoffmann frontends). */
export const DR_HOFFMANN_HANDOFF_HOSTS = new Set([
  "dr-hoffmann-massage.de",
  "www.dr-hoffmann-massage.de",
  "dr-hoffmann-client.onrender.com",
  "localhost",
]);

export const isDrHoffmannHandoffHost = (hostname) => {
  if (!hostname) return false;
  if (DR_HOFFMANN_HANDOFF_HOSTS.has(hostname)) return true;
  return (
    hostname.endsWith(".dr-hoffmann-massage.de") ||
    (hostname.endsWith(".onrender.com") && hostname.startsWith("dr-hoffmann"))
  );
};
